@if (isT1) {
    <wk-south-panel-t1 />
}
<div class="wk-cm__south-panel__actions">
    <button-field-pds3 type="primary" size="large" class="wk-cm__south-panel__actions-save">
        <button type="button" (click)="okClicked()">
            @if (cardModalService.showLoader()) {
                <app-loader [isOverlay]="false" size="button" position="left" [isLoading]="cardModalService.showLoader()" />
            }
            {{ "CardModal.Save" | translate }}
        </button>
    </button-field-pds3>

    <button-field-pds3 type="secondary" size="large" class="wk-cm__south-panel__actions-cancel">
        <button type="button" (click)="cancelClicked()">{{ "General.Close" | translate }}</button>
    </button-field-pds3>
</div>
